import GridCell from './_grid-cell.js'

export default {
  name: 'GridSeparator',
  values: {
    topSeparator: {
      configSet: GridCell,
      configValues: {
        style: undefined,
      },
    },
    bottomSeparator: {
      configSet: GridCell,
      configValues: {
        style: undefined,
      },
    },
  },
  meta: {
    extendable: false,
  },
}
